export default function Fourohfour() {
  return (
    <>
      <br />
      <br />
      <img id="png" src="/assets/404.png" width="235" height="120" border="0" />
      <br />
      sorry pal, this page is off the limits of our website..
      <br />
      check it&nbsp;out on another browser window.
    </>
  );
}
